// src/pages/Listings.js
import React from "react";

export default function Listings() {
  return (
    <div className="container page">
      <div className="page-header">
        <div>
          <h1>Florida Listings</h1>
          <p>
            Live MLS data updated in real time. Filter by price, beds, pools,
            waterfront, new construction, and more.
          </p>
        </div>
        <p className="page-note">
          Pro tip: Save your search and we’ll send you new matches the moment
          they hit the market.
        </p>
      </div>

      <div className="card idx-frame">
        <div className="idx-header">
          <span>Advanced Search (Powered by IDX)</span>
          <span>Listing information is provided by My Florida Regional MLS DBA Stellar MLS</span>
        </div>
        <div className="idx-body">
          {/* Replace this iframe src with your real IDX URL */}
          <iframe
            title="IDX Search"
            src="https://stellar.mlsmatrix.com/Matrix/Public/IDXMap.aspx?count=1&idx=9a377125&pv=&or="
            className="idx-iframe"
            loading="lazy"
          />
        </div>
      </div>

      <div className="page-footnote" style={{ marginTop: "1.5rem" }}>
        <p>
          Having trouble with the search? Text us your criteria and we’ll
          send you a curated list:&nbsp;
          <a href="tel:9417188317" className="highlight">941-718-8317</a>
        </p>

        {/* I changed this from a <div> to a <footer> and added <small> 
           for better SEO and standard web practices.
        */}
        <footer
          style={{
            fontSize: "12px",
            lineHeight: 1.4,
            maxWidth: "900px",
            margin: "0 auto",
            opacity: 0.7,
          }}
        >
          <small>
            © {new Date().getFullYear()} Platinum Palm Properties. All Rights
            Reserved. Platinum Palm Properties – Florida Licensed Real Estate
            Brokerage. Broker: Yuliya Tkachuk, License #BK3384976 • Phone:&nbsp;
            <a href="tel:9417188317" style={{ color: 'inherit', textDecoration: 'none' }}>
              941-718-8317
            </a> 
            &nbsp;• Equal Housing Opportunity. All listings on this
            website are provided by My Florida Regional MLS DBA Stellar MLS via
            Internet Data Exchange (IDX). Information is deemed reliable but not
            guaranteed and should be independently verified.
          </small>
        </footer>
      </div>
    </div>
  );
}